import React from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import HoverOverlay from '../canvas/HoverOverlay';
// import "../../templates/vtex-apps/mz-styles-all.scss";
import './../../Canvas.scss';

import IconPackImport from '../canvas/IconPackImport';
import { IntlProvider } from 'react-intl';
import { footerPageObject, headerPageObject, selectedPageObject } from '../../redux/pagesSlice';
import { selectedToggleValue, toggleMobile } from '../../redux/canvasResolutionSlice';
import PagesImport from './PagesImport';
import CanvasCSSVariablesImport from '../canvas/CanvasCSSVariablesImport';
import _ from 'lodash';
import { hoverElement, setHoverElement } from '../../redux/hoverElementSlice';
import { findCompByIdRecursively } from '../../utils/functions';
import { selectComponent } from '../../redux/selectedComponentSlice';
import ImagesImport from '../canvas/ImagesImport';
import VisualizationComponentWrapper from './VisualizationComponentWrapper';

const CanvasSA = () => {
	const { viewId } = useParams();
	const dispatch = useDispatch();
	const headerLayout = useSelector(headerPageObject).pageData;
	const footerLayout = useSelector(footerPageObject).pageData;
	const toggleValue = useSelector(selectedToggleValue);
	const selectedPage = useSelector(selectedPageObject);
	const hoverEl = useSelector(hoverElement);
	const updateHover = _.debounce(handleHover, 50);
	const resize = _.debounce(handleResize, 250);

	// React.useEffect(()=>{
	//     const pageId = selectedPage?.pageId
	//     if(pageId && pageId !== window.location.hash.slice(1)){
	//         window.location.hash = pageId
	//     }

	// },[selectedPage.pageId])

	//modo de visualização
	function handleResize() {
		const w = document.body.clientWidth;
		if (w > 1024) return dispatch(toggleMobile(1920));
		if (w > 640) return dispatch(toggleMobile(1024));
		if (w <= 640) return dispatch(toggleMobile(467));
	}

	function handleHover(e) {
		if (e.ctrlKey) {
			const closest = e.target.dataset.selection ? e.target : e.target.closest('[data-selection]');

			if (closest) {
				const compId = closest.dataset.selection;
				const name = findCompByIdRecursively(selectedPage.pageData, compId)?.comp?.componentName;
				if (!name) return clearHover();
				dispatch(setHoverElement({ componentId: closest.dataset.selection, componentName: name, isCanvas: true }));
			} else {
				clearHover();
			}
		} else {
			clearHover();
		}
	}

	function clearHover() {
		dispatch(setHoverElement({ componentId: null, componentName: null }));
	}

	function handleRightClick(e) {
		e.preventDefault();
		e.stopPropagation();
		const parentComponentId = findFurthestComponentId(e.target);
		const componentId = e.target.closest('[data-selection]')?.dataset?.selection;

		if (!parentComponentId) return;
		const xPos = window.innerWidth / 2;
		const yPos = e.pageY + 'px';
		const comp = findCompByIdRecursively(selectedPage.pageData, parentComponentId)?.comp;
		let childComp;
		let closest;
		if (e.ctrlKey) {
			closest = e.target.dataset.selection == componentId ? e.target : e.target.closest('[data-selection]');
			if (!closest) return selectComponent(null);
			childComp = findCompByIdRecursively(selectedPage.pageData, closest.dataset.selection)?.comp;
		}
		dispatch(selectComponent({ props: comp ?? childComp, xPos, yPos, childComp }));
	}

	const findFurthestComponentId = (el) => {
		const parent = el.parentElement.closest('[data-selection]');
		if (parent) {
			return findFurthestComponentId(parent);
		}

		if (el?.classList.contains('modal')) {
			const triggerId = el?.dataset?.triggercomponentid;
			if (triggerId) {
				const element = document.querySelector(`[data-selection="${triggerId}"]`);
				console.log(triggerId);
				return findFurthestComponentId(element);
			} else {
				return el?.dataset?.selection;
			}
		}
		return el?.dataset?.selection;
	};

	React.useEffect(() => {
		if (hoverEl?.flag) {
			let el = document.querySelector(`[data-selection="${hoverEl.componentId}"]`);
			//if data componentname is VisibilityLayout
			if (el?.dataset?.componentname == 'VisibilityLayout') {
				el = el;
			}
			console.log(el);
			console.log(hoverEl);
			if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}, [hoverEl]);

	React.useEffect(() => {
		window.addEventListener('resize', resize);
		return () => window.removeEventListener('resize', resize);
	}, []);

	return (
		<React.Fragment>
			<PagesImport viewId={viewId} />
			{/* <VisualizationIframeSA w={toggleValue >= 1080 ? "100%" : toggleValue + "px"} h={"100%"}> */}
			<link rel="stylesheet" href="/iframeCss.css" />
			<CanvasCSSVariablesImport viewId={viewId} />
			<ImagesImport viewId={viewId} />
			<IconPackImport />
			<IntlProvider locale="br" defaultLocale="br">
				<VisualizationComponentWrapper
					{...{ updateHover, handleRightClick, selectedPage, headerLayout, footerLayout, toggleValue }}
				/>
			</IntlProvider>
			<HoverOverlay />
			{/* </VisualizationIframeSA> */}
		</React.Fragment>
	);
};

export default CanvasSA;
